import { createContext } from 'react';

export const SpinnerContext = createContext(null);
